import { inject } from '@angular/core'
import { CanActivateFn, GuardResult } from '@angular/router'
import { Observable, of, switchMap } from 'rxjs'
import { AdministrationService } from '../services/administration/administration.service'
import { AuthService } from '../services/auth/auth.service'

/**
 * Check if user is allowed to administrate in, try (and wait for) a token refresh if necessary.
 * Otherwise, (logged out and no refresh token) redirect to root path "/".
 */
export const AdminGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService)
  const administrationService = inject(AdministrationService)

  return authService.getAuthResult().pipe(
    switchMap((_): Observable<GuardResult> => {
      return of(administrationService.showAdministrationMenu)
    })
  )
}
